import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-flex flex-row flex-sm-row align-center justify-center" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "font-tiny-xs ml-sm-1 text-break-new-line" }, "Swap Assets", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "font-ad-here text-info" }, "advertise here", -1);
const _hoisted_4 = { class: "d-flex flex-row flex-sm-row align-center justify-center" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "font-tiny-xs ml-sm-1 text-break-new-line" }, "Buy Crypto", -1);
const _hoisted_6 = { class: "d-flex flex-row flex-sm-row align-center justify-center" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("p", { class: "font-tiny-xs ml-sm-1 text-break-new-line" }, "Trade NFTs", -1);
import { useDisplay } from 'vuetify/lib/framework.mjs';
import { ROUTE_NAME } from '@core/router/routesNames';
import { useGtag } from 'vue-gtag-next';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppAdButtonsSmall',
    setup(__props) {
        const { xs } = useDisplay();
        const { event } = useGtag();
        const btnClick = (btnValue) => {
            event(`small-button-click-${btnValue}`, {
                event_category: 'btn-promo-click',
                event_label: `btn-small-${btnValue}`
            });
        };
        return (_ctx, _cache) => {
            const _component_v_img = _resolveComponent("v-img");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createBlock(_component_v_row, {
                align: "center",
                class: "justify-start justify-lg-end"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                        cols: "auto",
                        style: { "position": "relative" }
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                rounded: "pill",
                                elevation: "0",
                                height: _unref(xs) ? 22 : 30,
                                "min-width": _unref(xs) ? 68 : 151,
                                href: "https://www.myetherwallet.com/",
                                target: "_blank",
                                class: "promo-btn text-white",
                                onClick: _cache[0] || (_cache[0] = ($event) => (btnClick('swap-assets')))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        (!_unref(xs))
                                            ? (_openBlock(), _createBlock(_component_v_img, {
                                                key: 0,
                                                src: require('@/assets/logo/mew-long-white.png'),
                                                eager: "",
                                                contain: "",
                                                alt: "MyEtherWallet button icon",
                                                height: "14",
                                                width: "50"
                                            }, null, 8, ["src"]))
                                            : _createCommentVNode("", true),
                                        _hoisted_2
                                    ])
                                ]),
                                _: 1
                            }, 8, ["height", "min-width"]),
                            _createVNode(_component_router_link, {
                                to: _unref(ROUTE_NAME).ADVERTISE.PATH,
                                class: "ad-here-link"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_3
                                ]),
                                _: 1
                            }, 8, ["to"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                rounded: "pill",
                                elevation: "0",
                                color: "secondary",
                                height: _unref(xs) ? 22 : 30,
                                "min-width": _unref(xs) ? 68 : 151,
                                href: "https://ccswap.myetherwallet.com/?platform=ethvm",
                                target: "_blank",
                                class: "promo-btn text-white",
                                onClick: _cache[1] || (_cache[1] = ($event) => (btnClick('buy-crypto')))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_4, [
                                        (!_unref(xs))
                                            ? (_openBlock(), _createBlock(_component_v_img, {
                                                key: 0,
                                                src: require('@/assets/promo/buy-crypto.png'),
                                                eager: "",
                                                contain: "",
                                                alt: "MEW logo button icon",
                                                height: "18",
                                                width: "20",
                                                class: "mt-1"
                                            }, null, 8, ["src"]))
                                            : _createCommentVNode("", true),
                                        _hoisted_5
                                    ])
                                ]),
                                _: 1
                            }, 8, ["height", "min-width"])
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "auto" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                                rounded: "pill",
                                elevation: "0",
                                color: "secondary",
                                height: _unref(xs) ? 22 : 30,
                                "min-width": _unref(xs) ? 68 : 151,
                                href: "https://rarible.com/?ref=0x5bA9576c214FC7C6649f6F3C73dcbC2769b1761",
                                target: "_blank",
                                class: "promo-btn text-white",
                                onClick: _cache[2] || (_cache[2] = ($event) => (btnClick('trade-nfts')))
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                        (!_unref(xs))
                                            ? (_openBlock(), _createBlock(_component_v_img, {
                                                key: 0,
                                                src: require('@/assets/promo/rarible-icon.png'),
                                                eager: "",
                                                contain: "",
                                                alt: "MEW logo button icon",
                                                height: "16",
                                                width: "16"
                                            }, null, 8, ["src"]))
                                            : _createCommentVNode("", true),
                                        _hoisted_7
                                    ])
                                ]),
                                _: 1
                            }, 8, ["height", "min-width"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
